import { OpenAPIClientAxios } from 'openapi-client-axios';
import definition from './api-schema.json';

const release = (process.env.RELEASE === 'production') ? 'production' : 'staging';

const api = new OpenAPIClientAxios({
  definition,
  withServer: release,
  validate: true,
  axiosConfigDefaults: {
    withXSRFToken: false,
    withCredentials: false,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  },
});

api.init();

export default api;
